import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const showSharePopupAction = (shareConfig?: any): FluxStandardAction => {
    return {
        type: Actions.SHOW_SHARE_POPUP,
        payload: shareConfig
    }
};

export const hideSharePopupAction = (): FluxStandardAction => {
    return {
        type: Actions.HIDE_SHARE_POPUP,
    }
};